import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { LogoLoaderModule } from '@y42/core/logo-loader';
import { VsCodeEditorComponent } from './vscode-editor.component';

@NgModule({
  declarations: [VsCodeEditorComponent],
  imports: [LogoLoaderModule, CommonModule],
  exports: [VsCodeEditorComponent],
})
export class VsCodeEditorModule {}
